import React from 'react';
import { Link } from 'react-router-dom';
import { HeartPulse, Award, Shield, CheckCircle } from 'lucide-react';
import { AnimatedSection } from '../components/AnimatedSection';
import { CertificationAuthority } from '../components/CertificationAuthority';
import { EcosystemGrid } from '../components/EcosystemGrid';
export function AboutPage() {
  return <div className="w-full bg-warm-white" data-id="element-183">
      {/* Header */}
      <div className="bg-primary-900 text-warm-white py-20 lg:py-28" data-id="element-184">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-185">
          <h1 className="text-4xl lg:text-6xl font-heading mb-6" data-id="element-186">
            Why PawVerse Exists
          </h1>
          <p className="text-xl text-primary-100 font-body max-w-2xl mx-auto" data-id="element-187">
            We believe every pet owner should have the skills to save their
            pet's life. Here's how we're making that happen.
          </p>
        </div>
      </div>

      {/* Ecosystem */}
      <EcosystemGrid data-id="element-188" />

      {/* Credentials */}
      <CertificationAuthority data-id="element-189" />

      {/* Story Section */}
      <AnimatedSection className="py-20 lg:py-24" data-id="element-190">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-191">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-192">
            <div className="order-2 lg:order-1" data-id="element-193">
              <h2 className="text-3xl lg:text-4xl font-heading text-primary-900 mb-6" data-id="element-194">
                From Emergency Rooms to Your Living Room
              </h2>
              <div className="space-y-6 font-body text-lg text-warm-gray-700 leading-relaxed" data-id="element-195">
                <p data-id="element-196">
                  Hello! I'm Jessica, the founder and lead instructor at
                  PawVerse. My journey into pet safety training began during my
                  10 years working as a veterinary technician in busy Bay Area
                  emergency clinics.
                </p>
                <p data-id="element-197">
                  Time and time again, I saw dedicated, loving pet parents rush
                  through our doors with a pet in crisis. The heartbreaking
                  reality was that in many cases—like choking or severe
                  bleeding—the most critical window for saving the animal had
                  already passed during the car ride to the clinic.
                </p>
                <p data-id="element-198">
                  I realized that while human CPR and first aid are common
                  knowledge, pet first aid is rarely taught. I decided to change
                  that. I became a certified PetTech Instructor to bring
                  professional, hands-on pet CPR training directly to the
                  community.
                </p>
                <p data-id="element-199">
                  Today, PawVerse is proud to be a premier Bay Area pet safety
                  instructor, training everyone from first-time puppy owners to
                  entire staffs at high-volume doggy daycares.
                </p>
              </div>
            </div>
            <div className="order-1 lg:order-2 flex justify-center" data-id="element-200">
              <div className="relative max-w-sm" data-id="element-201">
                <div className="absolute inset-0 bg-primary-50 rounded-[2rem] transform -translate-x-3 translate-y-3 opacity-60" data-id="element-202"></div>
                <img src="https://cdn.magicpatterns.com/uploads/tAYd4KeRHKAKf1uGq9kcGM/Screenshot_2026-03-11_at_10.50.47_AM.png" alt="Jessica, PawVerse Instructor" className="relative rounded-[2rem] shadow-warm w-full object-cover aspect-[3/4]" data-id="element-203" />
              </div>
            </div>
          </div>
        </div>
      </AnimatedSection>

      {/* CTA */}
      <AnimatedSection className="py-20" data-id="element-204">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-205">
          <h2 className="text-3xl lg:text-4xl font-heading text-primary-900 mb-6" data-id="element-206">
            Ready to learn from a pro?
          </h2>
          <p className="text-lg text-warm-gray-600 font-body mb-8" data-id="element-207">
            Schedule an on-site training session for your home, team, or
            organization.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-208">
            <Link to="/programs" className="inline-flex justify-center items-center px-8 py-4 border border-transparent text-base font-medium rounded-full text-warm-white bg-primary-800 hover:bg-primary-700 shadow-warm transition-all" data-id="element-209">
              View Training Options
            </Link>
            <Link to="/contact" className="inline-flex justify-center items-center px-8 py-4 border-2 border-primary-800 text-base font-medium rounded-full text-primary-800 bg-transparent hover:bg-primary-50 transition-all" data-id="element-210">
              Contact Jessica
            </Link>
          </div>
        </div>
      </AnimatedSection>
    </div>;
}